export interface LinkedSurface {
  path: string
  label: string
}

function asObject(value: unknown): Record<string, unknown> | null {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : null
}

function firstString(...values: unknown[]): string | null {
  for (const value of values) {
    if (typeof value === 'string' && value.trim().length > 0) return value
  }
  return null
}

export function resolveOliviumLinkedSurface(
  item: Record<string, unknown>,
): LinkedSurface | null {
  const detail = asObject(item.detail)
  const payload = asObject(item.payload_json)

  const projectId = firstString(item.project_id, detail?.project_id, payload?.project_id)
  const workspaceId = firstString(item.workspace_id, detail?.workspace_id, payload?.workspace_id)
  const siteId = firstString(detail?.site_id, payload?.site_id)
  const deploymentId = firstString(
    item.deployment_id,
    detail?.deployment_id,
    payload?.deployment_id,
  )
  const requestId = firstString(
    detail?.request_id,
    payload?.request_id,
    item.resource_type === 'sq_support_request' ? item.resource_id : null,
  )
  const filePath = firstString(
    detail?.file_path,
    payload?.file_path,
    item.resource_type === 'storage' ? item.resource_id : null,
  )

  if (requestId) {
    return {
      path: `/square/command-center/operations?request=${encodeURIComponent(requestId)}`,
      label: 'Open request',
    }
  }

  if (deploymentId && projectId) {
    return {
      path: `/square/projects/${projectId}/hosting`,
      label: 'Open hosting',
    }
  }

  if (siteId && projectId) {
    return {
      path: `/square/projects/${projectId}/site`,
      label: 'Open site',
    }
  }

  if (workspaceId && projectId) {
    return {
      path: `/square/projects/${projectId}/studio`,
      label: 'Open studio',
    }
  }

  if (projectId) {
    return {
      path: `/square/projects/${projectId}`,
      label: 'Open project',
    }
  }

  if (filePath) {
    return {
      path: '/square/command-center/workspaces/vault',
      label: 'Open files',
    }
  }

  if (firstString(item.command_id, payload?.command_id)) {
    return {
      path: '/square/comms',
      label: 'Open comms',
    }
  }

  return null
}
